// src/pages/CreateCircuitChooser.jsx
// Schermata di scelta della modalità di creazione circuito:
//  - Automatica  → track builder GPS (CreateCircuit.jsx)
//  - Manuale     → editor a tavolino su mappa satellitare (ManualCircuitEditor.jsx)
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateCircuitChooser.css';

const ModeCard = ({ accent, onClick, badge, title, subtitle, points, icon }) => (
  <button className="ccc-card" style={{ '--accent': accent }} onClick={onClick}>
    <span className="ccc-card-glow" aria-hidden="true" />
    <span className="ccc-card-icon">{icon}</span>
    <span className="ccc-card-badge">{badge}</span>
    <span className="ccc-card-title">{title}</span>
    <span className="ccc-card-subtitle">{subtitle}</span>
    <ul className="ccc-card-points">
      {points.map((p, i) => (
        <li key={i}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
          <span>{p}</span>
        </li>
      ))}
    </ul>
    <span className="ccc-card-cta">
      <span>Scegli</span>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
    </span>
  </button>
);

export default function CreateCircuitChooser() {
  const navigate = useNavigate();

  return (
    <div className="ccc-page">
      <div className="ccc-bg-grid" aria-hidden="true" />
      <div className="ccc-bg-glow" aria-hidden="true" />

      <div className="ccc-main">
        <button className="ccc-back" onClick={() => navigate('/circuiti')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
          <span>Circuiti</span>
        </button>

        <header className="ccc-header">
          <span className="ccc-kicker">NUOVO CIRCUITO</span>
          <h1>Come vuoi creare il circuito?</h1>
          <p>Scegli la modalità di tracciamento più adatta.</p>
        </header>

        <div className="ccc-grid">
          <ModeCard
            accent="var(--rs-red)"
            badge="In pista"
            title="Automatica"
            subtitle="Mappa il tracciato guidando con un dispositivo GPS"
            onClick={() => navigate('/circuiti/crea/automatica')}
            points={[
              'Registra la linea percorsa dal device',
              'Chiusura automatica del tracciato',
              'Ideale quando sei sul circuito',
            ]}
            icon={(
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                <line x1="12" y1="18" x2="12.01" y2="18" />
                <path d="M9 6h6" />
              </svg>
            )}
          />

          <ModeCard
            accent="var(--rs-lime)"
            badge="A tavolino"
            title="Manuale"
            subtitle="Disegna il circuito su mappa satellitare, anche da remoto"
            onClick={() => navigate('/circuiti/crea/manuale')}
            points={[
              'Cerca il circuito per nome sulla mappa',
              'Traccia bordi, cordoli e curve',
              'Settori, area box e traguardo inclusi',
            ]}
            icon={(
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
                <line x1="8" y1="2" x2="8" y2="18" />
                <line x1="16" y1="6" x2="16" y2="22" />
              </svg>
            )}
          />
        </div>
      </div>
    </div>
  );
}
